import React from 'react';
import createSVG from './createSVG';

const SearchIcon = ({style}) => (
  <path style={style} d="M16.208 17.808c-4.58 0-8.292-3.735-8.292-8.342 0-4.607 3.712-8.34 8.292-8.34S24.5 4.858 24.5 9.465c0 4.607-3.713 8.342-8.292 8.342zm-5.905-2.486L1 24.625l9.303-9.303z" stroke="#fff" strokeWidth="1.5" fill="none" fillRule="evenodd" strokeLinecap="round" />
);

export default createSVG(SearchIcon);
